import { Helmet } from "react-helmet-async";
import { Hero } from "../components/home/Hero";
import { AboutUs } from "../components/home/AboutUs";
import { About } from "../components/home/About";
import { Trainers } from "../components/home/Trainers";
import { CourseCategories } from "../components/home/CourseCategories";
import { Pricing } from "../components/home/Pricing";
import { Roadmaps } from "../components/home/Roadmaps";
import { Reviews } from "../components/home/Reviews";
import { ClientsMarquee } from "../components/home/ClientsMarquee";
import { Faq } from "../components/home/Faq";
import { ContactSection } from "../components/home/ContactSection";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>LearnWithTAC | 1-on-1 Network, Cloud, Cyber Security & AI Training</title>
        <meta
          name="description"
          content="India's first truly 1-on-1 IT security academy. Live classes, recordings, 24x7 labs, notes PDF & mock interviews by working MNC engineers — at affordable pricing."
        />
      </Helmet>
      <Hero />
      <AboutUs />
      <About />
      <Trainers />
      <CourseCategories />
      <Pricing />
      <Roadmaps />
      <Reviews />
      <ClientsMarquee />
      <Faq />
      <ContactSection />
    </>
  );
}
